<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>超级智能体工作站</el-breadcrumb-item>
        <el-breadcrumb-item>减重智能体</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      @cell-click="handleCellClick"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
      <template slot-scope="scope" slot="weightLoss">
        <el-button type="text" size="small" @click="toWeightLoss(scope.row)">查看档案</el-button>
      </template>
      <template slot-scope="scope" slot="body">
        <el-button type="text" size="small" @click="toBody(scope.row)">运动评估</el-button>
      </template>
      <!-- <template slot-scope="scope" slot="fat">
        <el-button type="text" size="small">查看肥胖并发症</el-button>
        <el-button v-if="false" @click="test(scope.row)">查看详情</el-button>
      </template>
      <template slot-scope="scope" slot="weightControl">
        <el-button type="text" size="small">查看体重控制策略</el-button>
        <el-button v-if="false" @click="test(scope.row)">查看详情</el-button>
      </template> -->
      <template slot-scope="scope" slot="homeExercise">
        <el-button type="text" size="small" @click.native="toMotion(scope.row)">查看运动处方</el-button>
      </template>
      <template slot-scope="scope" slot="clinicalExercise">
        <el-button type="text" size="small" @click="toClinicalExercise(scope.row)">查看营养处方</el-button>
      </template>
      <template slot-scope="scope" slot="behavior">
        <el-button type="text" size="small" @click="toLossWeightCognitivebehaviorald(scope.row)">查看认知行为治疗</el-button>
        <el-button v-if="false" @click="test(scope.row)">查看详情</el-button>
      </template>
      <template slot-scope="scope" slot="drug">
        <el-button type="text" size="small" @click.native="toDrug(scope.row)">查看药物方案</el-button>
      </template>
      <template slot-scope="scope" slot="follow">
        <el-button type="text" size="small" @click="toLossWeightFollow(scope.row)">查看临床随访</el-button>
      </template>
    </avue-crud>

    <!-- 自定义弹框 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="45%" top="1%">
      <div style="margin-left: 50px; margin-right: 50px">
        <avue-crud :option="option2" :data="body"></avue-crud>
      </div>
      <template #footer>
        <el-button type="primary" @click="dialogVisible = false">确认</el-button>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="weightControlShow" title="体重控制策略" width="30%">
      {{ weightControl }}
    </el-dialog>
  </basic-container>
</template>

<script>
import { getLossWeightUser, getBodyData, getWeightControl } from '@/api/health/manage'
import { getDetail } from '@/api/health/userjk'
import { mapGetters } from 'vuex'
import func from '@/util/func'

export default {
  data() {
    return {
      dialogVisible: false,
      params: {
        channel: window.localStorage.getItem('channel')
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: '序号',
        selection: true,
        tip: false,
        border: false,
        index: true,
        viewBtn: true,
        editBtn: true,
        addBtn: false,
        addBtnText: '新 增 数 据',
        delBtn: true,
        menu: false,
        // selection: true,
        searchSpan: 4,
        searchMenuSpan: 4,
        column: [
          {
            label: '用户姓名',
            prop: 'name',
            search: true,
            editDisabled: true,
            addDisabled: true,
            searchValue: ''
          },
          // {
          //   label: "联系方式",
          //   prop: "mobile",
          //   search: true,
          // },
          {
            label: '减重数字档案',
            prop: 'weightLoss'
          },
          {
            label: '运动评估',
            prop: 'body'
          },
          // {
          //   label: ' 肥胖并发症',
          //   prop: 'fat'
          // },
          // {
          //   label: '体重控制策略',
          //   prop: 'weightControl'
          // },
          {
            label: '运动处方',
            prop: 'homeExercise'
          },
          {
            label: '营养处方',
            prop: 'clinicalExercise'
          },
          {
            label: '认知行为治疗',
            prop: 'behavior'
          },
          {
            label: '药物方案',
            prop: 'drug'
          },
          {
            label: '临床随访',
            prop: 'follow'
          }
        ]
      },
      dialogTitle: '体成分数据',
      option2: {
        align: 'center', // 全局居中
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        header: false,
        label: false,
        searchMenuSpan: 5,
        // selection: true,
        column: [
          {
            label: '名称',
            prop: 'name'
          },
          {
            label: '详情',
            prop: 'value'
          }
        ]
      },
      body: [],
      weightControlShow: false,
      weightControl: '',
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  beforeRouteLeave(to, from, next) {
    const state = {
      params: { ...this.params },
      page: { ...this.page }
    }
    sessionStorage.setItem('lossWeight', JSON.stringify(state))
    next()
  },
  methods: {
    onLoad(page, params) {
      const savedState = sessionStorage.getItem('lossWeight')
      if (savedState) {
        const state = JSON.parse(savedState)
        page = state.page
        params = state.params
        this.page = state.page
        this.params = state.params
        this.option.column[0].searchValue = params.name
        console.log('name: ', params.name)
        console.log(this.option.column[0])
        sessionStorage.removeItem('lossWeight')
      }
      params.channel = window.localStorage.getItem('channel')
      getLossWeightUser(page.currentPage, page.pageSize, params).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377' && res.data.users.length > 0) {
          res.data.users.forEach(item => {
              // item.mobile = func.maskPhone(item.mobile);
              item.name = func.maskName(item.name);
          });
        }
        this.page.total = res.data.total
        this.data = res.data.users
        console.log(res.data.users)
      })
    },

    searchChange(params, done) {
      console.log('SeachChange?')
      params.channel = window.localStorage.getItem('channel')
      this.params = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem('channel')
      }
      this.onLoad(this.page, this.params)
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    },

    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },

    toWeightLoss(row) {
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        // path: "/agent/digitalarchive",
        path: '/agent/dataarchive',
        query: parameter
      })
    },

    handleCellClick(row, column, cell, event) {
      const key = column.columnKey
      console.log('key', key)
      if (key === 'fat') {
        this.dialogVisible = true
        getBodyData(row.wx_user_id).then(res => {
          this.body = res.data
        })
      }
      if (key === 'weightControl') {
        this.weightControlShow = true
        getWeightControl(row.wx_user_id).then(res => {
          this.weightControl = res.data
          console.log(this.weightControl)
        })
      }
    },

    toMotion(row) {
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/agent/homeMotion',
        query: parameter
      })
    },

    toDrug(row) {
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/agent/lossWeightDrug',
        query: parameter
      })
    },

    toLossWeightCognitivebehaviorald(row) {
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/agent/lossWeightCognitivebehaviorald',
        query: parameter
      })
    },

    toLossWeightFollow(row) {
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/agent/lossWeightFollow',
        query: parameter
      })
    },

    toBody(row) {
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/agent/lossWeightBodyData',
        query: parameter
      })
    },

    toClinicalExercise(row) {
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/agent/lossWeightClinicalExercise',
        query: parameter
      })
    }
  }
}
</script>
<style>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
